/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ListChangedData } from './listChangedData';
import { ToastConfig } from './toastConfig';


/**
 * WebSocket notification to all users: a list showing these objects can light up its refresh button.
 */
import {ValidatorFn, Validators} from "@angular/forms";

export interface ListChangedNotification { 
    /**
     * Always \'list.changed\'
     */
    readonly type: string;
    data: ListChangedData;
    toast?: ToastConfig | null;
}
export const ListChangedNotification_type_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const ListChangedNotification_data_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const ListChangedNotification_toast_Validators: ValidatorFn[] =
    [ ];


